/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class AccountingsContactDialog extends NoboxEntityDialog<AccountingsRow, any> {
        protected getFormKey() { return AccountingsContactForm.formKey; }
        protected form = new AccountingsContactForm(this.idPrefix);

        public getValue = (value:string,text:string) => { };

        constructor() {
            super();
        }
        handleResponsive() {

        }

        updateTitle() {
            this.dialogTitle = "Select Contact";
        }

        updateInterface() {
            super.updateInterface();
        }
        getToolbarButtons() {
            return [];
        }
        setValue(value: string) {
            Serenity.EditorUtils.setValue(this.form.IdContact, value);
        }
        getDialogButtons() {
            var btn = [];
            btn.push({
                text: "Cancel",
                click: () => {
                    this.dialogClose();
                }
            });
            btn.push({
                text: "Confirm",
                click: () => {
                    var value = this.form.IdContact.get_value();
                    var text = this.form.IdContact.text;
                    this.getValue(value, text);
                    this.dialogClose();
                }
            });
            return btn;
        }
    }
}